import { ChevronDown, ChevronUp } from '../icons';
import classNames from 'classnames';

type Props = {
    isOpen: boolean;
    onChangeIsOpen: (newValue: boolean) => void;
    label: React.ReactNode;
    children: React.ReactNode;
    class?: string;
};
export function Accordion({
    label,
    children,
    isOpen,
    onChangeIsOpen,
    class: className,
}: Props) {
    return (
        <>
            <div
                className={classNames(className, 'flex justify-between')}
                onClick={() => onChangeIsOpen(!isOpen)}
            >
                {label}
                {isOpen ? (
                    <ChevronUp />
                ) : (
                    <ChevronDown className="text-dark-red" />
                )}
            </div>
            {isOpen && children}
        </>
    );
}
